import React from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import ReactGA from 'react-ga';
import Root from '@/root';
import Layout from '@/layout';


// styles
import 'styles/main.scss';

// polyfills
const isServer = typeof window === 'undefined';
if (!isServer) {
  // trigger polyfill in client only so build doesnt break
  smoothscroll.polyfill();
  // initialize GA
  try {
    ReactGA.initialize('UA-138231159-1');
  } catch (error) {
  }
}

export const wrapRootElement = ({ element, ...props }) => {
  return (
    <Root>
      <Layout location={props.pathname}>{element}</Layout>
    </Root>
  );
};

export const wrapPageElement = ({ element, props }) => {
  return <>{element}</>;
};

export const onRouteUpdate = (state) => {
  ReactGA.pageview(state.location.pathname);
};
